export default __webpack_public_path__ + "static/media/history.48eeb966.svg";